import React, { useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InventoryAlerts = ({ products, onRestock }) => {
  if (!products || products?.length === 0) return null;

  return (
    <div className="bg-warning/10 border border-warning rounded-lg p-4 mb-6">
      <div className="flex items-start gap-3">
        <Icon name="AlertTriangle" size={24} className="text-warning flex-shrink-0 mt-1" />
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-foreground mb-2">
            Low Stock Alerts ({products?.length})
          </h3>
          <p className="text-sm text-muted-foreground mb-4">
            The following products are running low on stock and may need restocking:
          </p>
          <div className="space-y-2">
            {products?.slice(0, 5)?.map((product) => (
              <div
                key={product?.id}
                className="flex items-center justify-between p-3 bg-card rounded-lg border border-border"
              >
                <div className="flex-1">
                  <p className="font-medium text-foreground">{product?.name}</p>
                  <p className="text-sm text-muted-foreground">
                    Current: {product?.stock_quantity} | Threshold: {product?.low_stock_threshold} | Reorder: {product?.reorder_quantity}
                  </p>
                </div>
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => onRestock?.(product)}
                >
                  <Icon name="Package" size={16} className="mr-1" />
                  Restock
                </Button>
              </div>
            ))}
          </div>
          {products?.length > 5 && (
            <p className="text-sm text-muted-foreground mt-3">
              +{products?.length - 5} more products need attention
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default InventoryAlerts;